import { MDBBtn } from "mdb-react-ui-kit";
import { FC } from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import TagManager from "react-gtm-module";
import { shareFacebook, shareTwitter } from "@/utils/analytics/tagmanager";
import socialAndBrandSvg from "../../utils/svg-icon/socialAndBrand";
import styles from "../../styles/common/SocialBtn.module.scss";
import { useIsClient } from "../../utils/hooks/useIsClient";

export type TSocialIcon = "FacebookLine" | "TwitterLine";

const SocialBtn: FC<{
    social: TSocialIcon;
    margin?: string;
    className?: string;
}> = ({
    social,
    className = `shadow-0 ${styles.socialBtn}`,
    margin = "ms-2",
}) => {
    const SocialIcon = Object.keys(socialAndBrandSvg).includes(social)
        ? socialAndBrandSvg[social]
        : socialAndBrandSvg.FacebookLine;

    const href = (url: string) => {
        switch (social) {
            case "FacebookLine":
                return `https://www.facebook.com/sharer/sharer.php?u=${url}`;
            case "TwitterLine":
                return `https://twitter.com/intent/tweet?url=${url}`;
            default:
                return "#";
        }
    };

    const isClient = useIsClient();

    const onClickMethod = (id: string, url: string) => {
        switch (id) {
            case "FacebookLine":
                TagManager.dataLayer(shareFacebook(url));
                break;
            case "TwitterLine":
                TagManager.dataLayer(shareTwitter(url));
                break;
            default:
                break;
        }
    };

    return (
        isClient && (
            <MDBBtn
                size="lg"
                floating
                href={href(window.location.href)}
                className={`${margin} ${className}`}
                id={social}
                onClick={() => onClickMethod(social, window.location.href)}
            >
                <div className="d-flex justify-content-center align-items-center w-100 h-100">
                    <SocialIcon />
                </div>
            </MDBBtn>
        )
    );
};

export default SocialBtn;
